export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_08_blank.24797807.png";